import styled from 'styled-components'

export default styled('div')`
  color: ${props => props.theme.input.labelColor};
  font-size: 13px;
  display: ${({ children }) => children ? 'block' : 'none'};
  margin-bottom: 6px;
`
